/**
 * Checkbox Group
 */

export class GMXCheckboxGroup extends HTMLElement {
	checkboxeEls: NodeListOf<HTMLInputElement>

	private boundCheckboxInputChangeHandler = this._handleCheckboxInputChange.bind(this)

	get maxNumberSelections(): number | null {
		const maxNum = parseInt(this.getAttribute('data-max-selections'), 10)
		return !isNaN(maxNum) ? maxNum : null
	}
	set maxNumberSelections(val: number) {
		this.setAttribute('data-max-selections', val.toString())
	}

	connectedCallback(): void {
		this.checkboxeEls = this.querySelectorAll('input[type="checkbox"]')

		this.addEventListener('change', this.boundCheckboxInputChangeHandler)
	}

	disconnectedCallback(): void {
		this.removeEventListener('change', this.boundCheckboxInputChangeHandler)
	}

	/**
	 * Callback for handling when a checkbox value has changed
	 * @private
	 */
	private _handleCheckboxInputChange(): void {
		let numChecked = 0

		this.classList.remove('invalid')

		if (this.maxNumberSelections) {
			this.checkboxeEls.forEach(el => {
				if (el.checked) {
					numChecked++
				}
			})

			this.checkboxeEls.forEach(el => {
				if (numChecked >= this.maxNumberSelections && !el.checked) {
					el.setAttribute('disabled', '')
				} else {
					el.removeAttribute('disabled')
				}
			})
		}
	}
}

if (!customElements.get('gmx-checkbox-group')) {
	customElements.define('gmx-checkbox-group', GMXCheckboxGroup)
}
